import PodcastColorTypes from "types/podcastColorTypes";

export function getPodcastThemeToken(prop: PodcastColorTypes): `podcast.${PodcastColorTypes}` {
  return `podcast.${prop}`;
}
